module.exports = __webpack_public_path__ + "sm.758d5f5b45e8964ff5a5.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/sm.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/sm.svg
// module chunks = styles